import "core-js/stable"
import "regenerator-runtime/runtime"
import "chart.js/auto"
import "antd/dist/antd.css"
import React from "react"
import ReactDOM from "react-dom"
import ChatBotLauncher from "../components/ChatBotLauncher"

// Support component names relative to this directory:
const componentRequireContext = require.context("components", true)
const ReactRailsUJS = require("react_ujs")

ReactRailsUJS.useContext(componentRequireContext)

document.addEventListener("DOMContentLoaded", () => {
  // Check if we are on the sign-in page
  const isSignInPage = window.location.pathname.includes("sign_in")

  if (!isSignInPage) {
    const chatDiv = document.createElement("div")
    chatDiv.id = "chatbot-global"
    document.body.appendChild(chatDiv)

    ReactDOM.render(
      React.createElement(ChatBotLauncher, { setHasInteracted: () => {} }),
      chatDiv,
    )
  }
})
